var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select-with-validation',_vm._g(_vm._b({attrs:{"items":_vm.entityOptions,"label":_vm.label,"value":_vm.value},on:{"input":_vm.updateValue}},'v-select-with-validation',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }